import { ISubjectGoldPrice } from "api/types/_campaign";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from "common/toast";
import { useFormik } from "formik";
import { TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT, TEMPLATE_ELEMENT_TYPE_BOOSTING_CONTENT } from "helpers/constans";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import 'react-json-pretty/themes/monikai.css';
import "react-quill/dist/quill.snow.css";
import { toast } from "react-toastify";
import { Col, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { postSubjectGoldPrice, putSubjectGoldPrice } from "store/campaign/thunk";
import * as Yup from "yup";

export interface Props {
    isOpen?: boolean;
    detail?: ISubjectGoldPrice | null,
    onClose?: () => void
    triggerRefresh?: (type?: string) => void;
}

const SubjectForm = ({
    isOpen = false,
    detail = null,
    onClose,
    triggerRefresh
}: Props) => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const onCloseClick = () => {
        onClose && onClose();
    }
    const handleSubmit = async (values: any) => {
        try {
            setIsLoading((_prev) => true);
            const data = {
                name: values?.name || '',
                content: values?.content || '',
                ...(!!detail?.id ? {} : { category: TEMPLATE_CATEGORY_TYPE_BOOSTING_CONTENT.GOLD_PRICE, element_type: TEMPLATE_ELEMENT_TYPE_BOOSTING_CONTENT.TITLE, })
            };
            const response: any = !!detail?.id ? await putSubjectGoldPrice(detail?.id, data) : await postSubjectGoldPrice(data);
            if (response?.code === 200) {
                setIsLoading((_prev) => false);
                toast(
                    `${t("The process has been completed.")}`,
                    CONFIG_OPTION_TOAST_NORMAL
                );
                triggerRefresh && triggerRefresh();
            } else {
                setIsLoading((_prev) => false);
                toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
            }
        } catch (error: any) {
            setIsLoading((_prev) => false);
            toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    const validationSchema = Yup.object({
        name: Yup.string().required(`${t("This is required")}`),
        content: Yup.string().required(`${t("This is required")}`),
    });

    const formik = useFormik({
        initialValues: {
            name: '',
            content: '',
        },
        validationSchema,
        onSubmit: handleSubmit,
    });

    useEffect(() => {
        const handleCallAllOption = async () => {
            try {
                const _name = detail?.name || '';
                const _content = detail?.content || '';

                formik.setFieldValue('name', _name);
                formik.setFieldValue('content', _content);
                setTimeout(() => {
                    formik.setErrors({});
                }, 300);
            } catch (error: any) {
                // setIsLoadingDetail((_prev) => false);
                return error;
            }
        };
        handleCallAllOption();
    }, [JSON.stringify(detail)]);

    return (
        <React.Fragment>
            <Modal
                isOpen={isOpen}
                centered={true}
                size="md"
                className={`border-header-footer`}
                scrollable={false}
                toggle={onCloseClick}
                keyboard={true}
            >
                <ModalHeader toggle={onCloseClick} className="modal-title-flex-grow-1">
                    <div className="d-flex flex-column gap-0 gap-sm-2 fs-18 fs-md-20">
                        <div className="flex-grow-1">
                            <>{!!detail?.id ? t('Button Update Subject') : t('Button Create Subject')}</>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="position-relative">
                    <div>
                        <form onSubmit={formik.handleSubmit}>
                            <Row>
                                <Col sm={12} className="mb-3">
                                    <Label htmlFor="name" className="form-label">{t('Name')} <span className="text-danger"> *</span></Label>
                                    <Input
                                        name="name"
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        placeholder={t('Name')}
                                        value={formik?.values?.name}
                                        onChange={(event: any) => formik.setFieldValue('name', event?.target?.value)}
                                    />
                                    {formik.touched.name && formik.errors.name ? (
                                        <div className="text-danger mt-2">{formik.errors.name}</div>
                                    ) : null}
                                </Col>
                                <Col sm={12} className="mb-3">
                                    <Label htmlFor="content" className="form-label">{t('Template')} <span className="text-danger"> *</span></Label>
                                    <Input
                                        name="content"
                                        type="textarea"
                                        rows={10}
                                        className="form-control"
                                        id="content"
                                        placeholder={t('Template')}
                                        value={formik?.values?.content}
                                        onChange={(event: any) => formik.setFieldValue('content', event?.target?.value)}
                                    />
                                    {formik.touched.content && formik.errors.content ? (
                                        <div className="text-danger mt-2">{formik.errors.content}</div>
                                    ) : null}
                                </Col>
                                <Col sm={12} className="mb-2" >
                                    <div className="d-flex gap-3 justify-content-end align-item-center">
                                        <button
                                            className="btn btn-primary fs-14 px-1 d-flex justify-content-center align-item-center"
                                            type="submit"
                                            style={{ width: '150px' }}
                                            disabled={isLoading}
                                        >
                                            {isLoading && <span style={{ transform: 'translateY(1px)' }} className="me-1"><Spinner size="sm"></Spinner></span>}<span>{
                                                !!detail?.id ? t('Button Update Subject') : t('Button Create Subject')
                                            }</span>
                                        </button>
                                        <button
                                            className="btn btn-secondary fs-14 px-1 d-flex justify-content-center align-item-center"
                                            type="button"
                                            onClick={onCloseClick}
                                            style={{ width: '75px' }}
                                        >
                                            <i className="ri-close-fill" style={{ lineHeight: '22px' }} /> <span className="ms-1">{t("Button Close")}</span>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment >
    );
};

export default SubjectForm;

